(function () {
  'use strict';
  if (window.__fsStickyPurchase) return;
  window.__fsStickyPurchase = true;
  var cleanup = null;
  function init() {
    if (cleanup) cleanup();
    var config = document.querySelector('script[data-fs-sticky-settings]');
    var addEnabled = !!config && config.dataset.stickyAddEnabled === 'true';
    var buyEnabled = !config || config.dataset.stickyBuyEnabled !== 'false';
    var addLabel = config && (config.dataset.stickyAddLabel || '').trim();
    var buyLabel = config && (config.dataset.stickyBuyLabel || '').trim();
    if (!addEnabled && !buyEnabled) return;
    var root = document.querySelector('[data-product-detail]');
    var original = root && root.querySelector('[data-add-to-cart]');
    var form = original && original.form;
    var anchor = original && original.closest('.product-detail-actions');
    if (!form || !anchor || !window.IntersectionObserver) return;
    var variants;
    try { variants = JSON.parse(root.querySelector('[data-product-variants]').textContent); }
    catch (_) { return; }
    var de = document.documentElement.lang.indexOf('de') === 0;
    var bar = document.createElement('aside');
    bar.className = 'fs-sticky-purchase' + (addEnabled && buyEnabled ? ' fs-sticky-purchase--dual' : '');
    bar.hidden = true;
    bar.setAttribute('aria-label', de ? 'Produkt kaufen' : 'Product purchase');
    var inner = document.createElement('div');
    inner.className = 'fs-sticky-purchase__inner';
    var info = document.createElement('div');
    info.className = 'fs-sticky-purchase__info';
    var title = document.createElement('strong');
    title.className = 'fs-sticky-purchase__title';
    title.textContent = (root.querySelector('h1') || {}).textContent || '';
    var detail = document.createElement('span');
    detail.className = 'fs-sticky-purchase__detail';
    var price = document.createElement('span');
    price.className = 'fs-sticky-purchase__price';
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'fs-sticky-purchase__button';
    var uncertain = false;
    var error = document.createElement('div');
    error.className = 'fs-sticky-purchase__error';
    error.setAttribute('role', 'alert');
    error.hidden = true;
    error.style.cssText = 'max-width:1380px;margin:8px auto 0;font-size:13px;color:#9b1c1c;overflow-wrap:anywhere';
    var addButton = document.createElement('button');
    addButton.type = 'button';
    addButton.className = 'fs-sticky-purchase__button fs-sticky-purchase__cart';
    var actions = document.createElement('div');
    actions.className = 'fs-sticky-purchase__actions';
    if (addEnabled) actions.append(addButton);
    if (buyEnabled) actions.append(button);
    info.append(title, detail, price);
    inner.append(info, actions);
    bar.append(inner, error);
    document.body.append(bar);
    var spacer = document.createElement('div');
    spacer.className = 'fs-sticky-purchase__spacer';
    spacer.setAttribute('aria-hidden', 'true');
    document.body.append(spacer);
    var frame = 0;
    var dead = false;
    var preorder = root.classList.contains('product-detail--preorder') || !!root.querySelector('.presale-deposit, [data-deposit-price]');
    function selected() {
      var id = new FormData(form).get('id');
      return variants.find(function (variant) { return String(variant.id) === String(id); });
    }
    function sync() {
      var variant = selected();
      button.textContent = window.__fsStickyCheckoutPending ? (de ? 'Wird geladen…' : 'Processing…') : (variant && !variant.available ? (original.getAttribute('data-sold-out-label') || (de ? 'Ausverkauft' : 'Sold out')) : (buyLabel || 'Buy it now'));
      var originalStyle = getComputedStyle(original);
      ['background-color', 'color', 'border-top-color', 'border-top-width', 'border-top-style', 'border-radius', 'font-family', 'font-weight'].forEach(function (property) {
        var target = property.replace('border-top-', 'border-');
        button.style.setProperty(target, originalStyle.getPropertyValue(property));
        addButton.style.setProperty(target, originalStyle.getPropertyValue(property));
      });
      button.disabled = !!window.__fsStickyCheckoutPending || uncertain || original.disabled || original.getAttribute('aria-disabled') === 'true' || !variant || !variant.available;
      button.setAttribute('aria-busy', window.__fsStickyCheckoutPending ? 'true' : (original.getAttribute('aria-busy') || 'false'));
      addButton.disabled = button.disabled;
      addButton.setAttribute('aria-busy', button.getAttribute('aria-busy'));
      addButton.textContent = variant && !variant.available ? button.textContent : (addLabel || (de ? 'In den Warenkorb' : 'Add to cart'));
      var options = variant && variant.options ? variant.options.filter(function (v) { return v !== 'Default Title'; }).join(' / ') : '';
      var quantityInput = root.querySelector('[data-product-quantity]:not([type="hidden"])') || form.querySelector('[name="quantity"]');
      var quantity = quantityInput ? quantityInput.value : '1';
      detail.textContent = [options, quantity !== '1' ? '× ' + quantity : ''].filter(Boolean).join(' · ');
      // Use the checkout variant price, never a manual campaign/presale display price.
      var plain = document.createElement('div');
      plain.innerHTML = variant ? variant.priceFormatted || '' : '';
      price.textContent = (preorder ? (de ? 'Anzahlung: ' : 'Deposit: ') : '') + plain.textContent;
    }
    function visible(el) {
      return el && !el.hidden && getComputedStyle(el).visibility !== 'hidden' && el.getClientRects().length > 0;
    }
    function update() {
      frame = 0;
      if (dead) return;
      sync();
      var blocked = Array.from(document.querySelectorAll('[aria-modal="true"], dialog[open], [data-header-panel], [data-region-overlay], [data-cart-drawer]')).some(visible);
      var active = document.activeElement;
      var typing = active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName);
      var viewport = window.visualViewport;
      var keyboard = viewport && viewport.height < window.innerHeight * 0.75;
      var show = anchor.getBoundingClientRect().bottom <= 0 && !blocked && !typing && !keyboard && visible(root);
      if (!show && bar.contains(active)) original.focus({preventScroll: true});
      bar.hidden = !show;
      spacer.style.height = show ? bar.getBoundingClientRect().height + 'px' : '0px';
      document.documentElement.style.setProperty('--fs-sticky-purchase-clearance', spacer.style.height);
    }
    function schedule() { if (!frame && !dead) frame = requestAnimationFrame(update); }
    addButton.addEventListener('click', function () {
      sync();
      if (addButton.disabled) return;
      if (!form.checkValidity()) {
        anchor.scrollIntoView({behavior: 'smooth', block: 'center'});
        form.reportValidity();
        return;
      }
      original.click();
      schedule();
    });
    button.addEventListener('click', async function () {
      sync();
      if (button.disabled || window.__fsStickyCheckoutPending) return;
      if (!form.checkValidity()) {
        anchor.scrollIntoView({behavior: 'smooth', block: 'center'});
        form.reportValidity();
        return;
      }
      var data = new FormData(form);
      var quantityInput = root.querySelector('[data-product-quantity]:not([type="hidden"])') || form.querySelector('[name="quantity"]');
      var quantity = quantityInput ? quantityInput.value : (data.get('quantity') || '1');
      if (!/^[1-9]\d*$/.test(String(quantity)) || (quantityInput && !quantityInput.checkValidity())) {
        if (quantityInput) {
          quantityInput.scrollIntoView({block: 'center'});
          quantityInput.focus();
          quantityInput.reportValidity();
        }
        return;
      }
      data.set('quantity', quantity);
      // Keep selling_plan and line-item properties, including uploaded files.
      data.delete('return_to');
      var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var base = new URL(route, window.location.origin);
      if (base.origin !== window.location.origin) return;
      if (!base.pathname.endsWith('/')) base.pathname += '/';
      var checkout = new URL('checkout', base);
      var cart = new URL('cart', base);
      window.__fsStickyCheckoutPending = true;
      sync();
      error.hidden = true;
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 20000);
      try {
        var response = await fetch(new URL('cart/add.js', base).href, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {'Accept': 'application/json'},
          body: data,
          signal: controller.signal
        });
        var result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error(typeof result.description === 'string' ? result.description : (de ? 'Der Artikel konnte nicht hinzugefügt werden.' : 'The item could not be added.'));
        }
        // Do not redirect unless Shopify confirms the requested item was added.
        var items = result.items || [result];
        if (!items.some(function (item) { return String(item.variant_id || item.id) === String(data.get('id')); })) {
          throw new Error(de ? 'Die Warenkorb-Antwort konnte nicht bestätigt werden.' : 'The cart response could not be confirmed.');
        }
        window.location.assign(checkout.href);
      } catch (failure) {
        // A failed/aborted response may still have changed the server cart.
        // Keep this attempt locked; never automatically repeat the add request.
        uncertain = true;
        window.__fsStickyCheckoutPending = false;
        if (!dead) {
          error.replaceChildren();
          var message = document.createElement('span');
          message.textContent = (failure.name === 'AbortError' || failure instanceof TypeError)
            ? (de ? 'Verbindung unterbrochen. Bitte prüfen Sie den Warenkorb, bevor Sie erneut bestellen. ' : 'Connection interrupted. Please check your cart before trying again. ')
            : failure.message + ' ';
          var review = document.createElement('a');
          review.href = cart.href;
          review.textContent = de ? 'Warenkorb prüfen' : 'Review cart';
          error.append(message, review);
          error.hidden = false;
          sync();
          schedule();
        }
      } finally {
        clearTimeout(timeout);
      }
    });
    var intersection = new IntersectionObserver(schedule, {threshold: [0, 1]});
    intersection.observe(anchor);
    var mutation = new MutationObserver(function (records) {
      if (records.some(function (r) { return !bar.contains(r.target) && r.target !== spacer; })) schedule();
    });
    mutation.observe(document.body, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'hidden', 'aria-hidden', 'open', 'class', 'value']});
    var resize = window.ResizeObserver ? new ResizeObserver(schedule) : null;
    if (resize) resize.observe(bar);
    ['change', 'input', 'focusin', 'focusout'].forEach(function (event) { document.addEventListener(event, schedule); });
    window.addEventListener('resize', schedule);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
    update();
    cleanup = function () {
      dead = true;
      cancelAnimationFrame(frame);
      intersection.disconnect(); mutation.disconnect();
      if (resize) resize.disconnect();
      ['change', 'input', 'focusin', 'focusout'].forEach(function (event) { document.removeEventListener(event, schedule); });
      window.removeEventListener('resize', schedule);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', schedule);
      bar.remove(); spacer.remove();
      document.documentElement.style.removeProperty('--fs-sticky-purchase-clearance');
      cleanup = null;
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { if (cleanup) cleanup(); });
})();


